<script>
import Button from '@/Components/Button/Button';

export default {
    extends: Button,

    props: {
        icon: {
            type: String,
            default: 'plus',
        },
        size: {
            type: String,
            default: 'sm',
        },
        color: {
            type: String,
            default: 'green',
        },
        label: {
            type: String,
            default: function() {
                return this.$t('form.create');
            },
        },
    },
};
</script>
